import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import ArticlesSection from './components/ArticlesSection';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sugargoospreadsheet.wtf';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Sugargoo Spreadsheet',
            url: siteUrl,
            description: 'The most comprehensive Sugargoo Spreadsheet resource with updated finds, guides, and category lists.',
          }),
        }}
      />

      <Navbar />

      <main>
        <article id="home">
          <Hero />
        </article>

        <section id="categories">
          <CategoryGrid />
        </section>

        <section id="cta">
          <CTASection />
        </section>

        <section id="blog">
          <ArticlesSection />
        </section>

        <section id="safety">
          <SafetySection />
        </section>

        <section id="guide">
          <FAQSection />
        </section>
      </main>

      <Footer />
    </>
  );
}